module.exports = __webpack_public_path__ + "img/3.af7eee3b.jpg";